import Vue from 'vue'
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
// Full Calendar Plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// eslint-disable-next-line object-curly-newline
import { ref, computed, watch, onMounted } from '@vue/composition-api'
import moment from 'moment'
import store from '@/store'

export default function useCalendar() {
  // Use toast
  const toast = useToast()
  // ------------------------------------------------
  // refCalendar
  // ------------------------------------------------
  const refCalendar = ref(null)

  // ------------------------------------------------
  // calendarApi
  // ------------------------------------------------
  let calendarApi = null

  // const { data } = await store
  //   .dispatch('calendar/fetchActivityTypes')

  // const { activityTypes } = data
  // const activityID = activityTypes.length ? activityTypes[0]._id : ''

  const customFields = ref([])

  const blankEvent = {
    startDate: '',
    startTime: '',
    allDay: false,
    title: '',
    editableTitle: '',
    showServiceDescription: false,
    deceasedNiche: '',
    deceasedPedestal: '',
    deceasedAngling: '',
    deceasedName: '',
    deceasedAge: '',
    deceasedGender: '',
    departedDate: '',
    customFields: [],
    paymentStatus: '',
    paymentRemarks: '',
    smsDate: '',
    emailDate: '',
    agentName: '',
    agentCode: '',
    status: '',
    agentContact: '',
    serviceRequestID: '',
    serviceFormID: '',
  }
  const eventDetail = ref(JSON.parse(JSON.stringify(blankEvent)))

  onMounted(() => {
    calendarApi = refCalendar.value.getApi()
  })

  // ------------------------------------------------
  // calendars
  // ------------------------------------------------
  // const calendarsColor = {
  //   SiteTours: 'warning',
  //   PayRespects: 'danger',
  //   Prayers: 'success',
  //   Events: 'primary',
  // }

  // ------------------------------------------------
  // event
  // ------------------------------------------------

  const clearEventData = () => {
    customFields.value = []
  }

  // *===========================================================================---*
  // *--------- Calendar API Function/Utils --------------------------------------------*
  // Template Future Update: We might move this utils function in its own file
  // *===========================================================================---*

  // ------------------------------------------------
  // (UI) addEventInCalendar
  // ? This is useless because this just add event in calendar and not in our data
  // * If we try to call it on new event then callback & try to toggle from calendar we get two events => One from UI and one from data
  // ------------------------------------------------
  // const addEventInCalendar = eventData => {
  //   toast({
  //     component: ToastificationContent,
  //     position: 'bottom-right',
  //     props: {
  //       title: 'Event Added',
  //       icon: 'CheckIcon',
  //       variant: 'success',
  //     },
  //   })
  //   calendarApi.addEvent(eventData)
  // }

  // ------------------------------------------------
  // (UI) updateEventInCalendar
  // ------------------------------------------------
  const updateEventInCalendar = (updatedEventData, propsToUpdate, extendedPropsToUpdate) => {
    // toast({
    //   component: ToastificationContent,
    //   props: {
    //     title: 'Event Title Updated',
    //     icon: 'CheckIcon',
    //     variant: 'success',
    //   },
    // })

    const existingEvent = calendarApi.getEventById(updatedEventData.id)

    // --- Set event properties except date related ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setProp
    // dateRelatedProps => ['start', 'end', 'allDay']
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < propsToUpdate.length; index++) {
      const propName = propsToUpdate[index]
      existingEvent.setProp(propName, updatedEventData[propName])
    }

    // --- Set date related props ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setDates
    // existingEvent.setDates(updatedEventData.startDate, updatedEventData.startDate, { allDay: updatedEventData.allDay })

    // --- Set event's extendedProps ----- //
    // ? Docs: https://fullcalendar.io/docs/Event-setExtendedProp
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < extendedPropsToUpdate.length; index++) {
      const propName = extendedPropsToUpdate[index]
      existingEvent.setExtendedProp(propName, updatedEventData.extendedProps[propName])
    }
  }

  // ------------------------------------------------
  // (UI) removeEventInCalendar
  // ------------------------------------------------
  const removeEventInCalendar = eventId => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Event Removed',
        icon: 'TrashIcon',
        variant: 'danger',
      },
    })
    calendarApi.getEventById(eventId).remove()
  }

  // ------------------------------------------------
  // grabEventDataFromEventApi
  // ? It will return just event data from fullCalendar's EventApi which is not required for event mutations and other tasks
  // ! You need to update below function as per your extendedProps
  // ------------------------------------------------
  const grabEventDataFromEventApi = eventApi => {
    const {
      id,
      title,
      start,
      end,
      backgroundColor,
      // eslint-disable-next-line object-curly-newline
      // eslint-disable-next-line no-empty-pattern
      extendedProps: {
        editableTitle, deceasedNiche, deceasedPedestal, deceasedAngling, deceasedName, deceasedAge, deceasedGender, departedDate, serviceFormID,
        wfCustomFields, paymentStatus, paymentRemarks, smsDate, emailDate, assignees, agentName, agentCode, agentContact, currentDate, serviceRequestID,
        customerName, customerContact, customerEmail, formStringID, dutyOfficer, workflowCategory, location, fileNo, remarks, formattedDate,
        showServiceDescription, oldServiceDescription, status, workFlowName, eventTime,
      },
      allDay,
    } = eventApi

    return {
      id,
      title,
      start,
      end,
      backgroundColor,
      extendedProps: {
        editableTitle,
        showServiceDescription,
        oldServiceDescription,
        customerName,
        customerContact,
        customerEmail,
        formStringID,
        dutyOfficer,
        deceasedNiche,
        deceasedPedestal,
        deceasedAngling,
        deceasedName,
        deceasedAge,
        deceasedGender,
        departedDate,
        wfCustomFields,
        paymentStatus,
        paymentRemarks,
        smsDate,
        emailDate,
        agentName,
        assignees,
        agentCode,
        agentContact,
        workflowCategory,
        currentDate,
        serviceRequestID,
        serviceFormID,
        location,
        fileNo,
        remarks,
        formattedDate,
        status,
        workFlowName,
        eventTime,
      },
      allDay,
    }
  }

  const calendarViewName = ref('dayGridMonth')

  // ------------------------------------------------
  // addEvent
  // ------------------------------------------------
  const addEvent = () => {
  }

  // ------------------------------------------------
  // updateEvent
  // ------------------------------------------------
  const updateEvent = eventData => {
    store.dispatch('operationCalendar/updateEvent', { event: eventData }).then(response => {
      const updatedEvent = response.data.event

      const propsToUpdate = ['id', 'title', 'url']
      const extendedPropsToUpdate = ['calendar', 'guests', 'location', 'description']

      updateEventInCalendar(updatedEvent, propsToUpdate, extendedPropsToUpdate)
    })

    Vue.swal({
      title: 'Title Updated',
      html: '',
      // eslint-disable-next-line global-require
      imageUrl: require('@/assets/images/icons/save.png'),
      imageWidth: 80,
      imageHeight: 80,
      imageAlt: 'Custom Icon',
      showCancelButton: false,
      allowOutsideClick: false,
      confirmButtonText: 'Okay',
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  }

  // ------------------------------------------------
  // removeEvent
  // ------------------------------------------------
  const removeEvent = () => {
    const eventId = 0
    store.dispatch('operationCalendar/removeEvent', { id: eventId }).then(() => {
      removeEventInCalendar(eventId)
    })
  }

  // ------------------------------------------------
  // refetchEvents
  // ------------------------------------------------
  const refetchEvents = () => {
    calendarApi.refetchEvents()
  }

  // ------------------------------------------------
  // selectedCalendars
  // ------------------------------------------------
  const selectedCalendars = computed(() => store.state.operationCalendar.selectedCalendars)

  watch([selectedCalendars, calendarViewName], () => {
    refetchEvents()
  })

  // --------------------------------------------------------------------------------------------------
  // AXIOS: fetchEvents
  // * This will be called by fullCalendar to fetch events. Also this can be used to refetch events.
  // --------------------------------------------------------------------------------------------------
  const fetchEvents = (info, successCallback) => {
    // If there's no info => Don't make useless API call
    if (!info) return
    // if (!selectedCalendars.value.length) return

    // Fetch Events from API endpoint
    store
      .dispatch('operationCalendar/fetchEvents', {
        calendars: selectedCalendars.value,
        view: calendarViewName.value,
        startDate: info.startStr,
        endDate: info.endStr,
      })
      .then(response => {
        successCallback(response.data.serviceRequests)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching calendar events',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchDayEvents = view => {
    if (calendarViewName.value !== view) {
      calendarViewName.value = view
    }

    if (calendarViewName.value !== 'dayGridMonth') {
      if (calendarApi) {
        calendarApi.setOption('displayEventTime', 'true')
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (calendarApi) {
        calendarApi.setOption('displayEventTime', false)
      }
    }
  }

  const changeCalendarView = date => {
    if (calendarApi) {
      calendarApi.gotoDate(date)
      calendarApi.changeView('timeGridDay')
    }
    refetchDayEvents('timeGridDay')
  }

  // ------------------------------------------------------------------------
  // calendarOptions
  // * This isn't considered in UI because this is the core of calendar app
  // ------------------------------------------------------------------------
  const calendarOptions = ref({
    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      start: 'sidebarToggle, prev,next, title',
      end: 'today, dayGridMonth,timeGridWeek,timeGridDay,listMonth',
    },
    // height: 1000,
    events: fetchEvents,

    /*
      Enable dragging and resizing event
      ? Docs: https://fullcalendar.io/docs/editable
    */
    editable: false,

    // locale: 'zh-cn',

    /*
      Enable resizing event from start
      ? Docs: https://fullcalendar.io/docs/eventResizableFromStart
    */
    eventResizableFromStart: false,

    /*
      Automatically scroll the scroll-containers during event drag-and-drop and date selecting
      ? Docs: https://fullcalendar.io/docs/dragScroll
    */
    dragScroll: false,

    /*
      Max number of events within a given day
      ? Docs: https://fullcalendar.io/docs/dayMaxEvents
    */
    dayMaxEvents: 2,

    /*
      Determines if day names and week names are clickable
      ? Docs: https://fullcalendar.io/docs/navLinks
    */
    navLinks: true,
    displayEventTime: false,
    // nextDayThreshold: '06:00:00',
    slotEventOverlap: false,
    // dayMaxEventRows: true,
    // dayMaxEventRows: 1,

    // eventClassNames({ event: calendarEvent }) {
    //
    //   const { colorName } = calendarEvent._def.extendedProps
    //   return [
    //     // Background Color
    //     `bg-light-${colorName}`,
    //   ]
    // },
    eventClick({ event: clickedEvent }) {
      // * Only grab required field otherwise it goes in infinity loop
      // ! Always grab all fields rendered by form (even if it get `undefined`) otherwise due to Vue3/Composition API you might get: "object is not extensible"
      eventDetail.value = grabEventDataFromEventApi(clickedEvent)
      if (calendarViewName.value === 'dayGridMonth' || calendarViewName.value === 'timeGridWeek') {
        changeCalendarView(clickedEvent._def.extendedProps.currentDate)
      } else {
        isEventDetailSidebarActive.value = true
      }
    },

    customButtons: {
      sidebarToggle: {
        // --- This dummy text actual icon rendering is handled using SCSS ----- //
        text: 'sidebar',
        click() {
          // eslint-disable-next-line no-use-before-define
          isCalendarOverlaySidebarActive.value = !isCalendarOverlaySidebarActive.value
        },
      },
    },

    dateClick(info) {
      /*
        ! Vue3 Change
        Using Vue.set isn't working for now so we will try to check reactivity in Vue 3 as it can handle this automatically
        ```
        event.value.start = info.date
        ```
      */
      if (!moment(info.date).isBefore(moment().subtract(1, 'days'))) {
        // eslint-disable-next-line no-use-before-define
        isEventHandlerSidebarActive.value = true
      }
    },

    // viewDidMount(view) {
    //   refetchDayEvents(view.view.type)
    // },

    viewClassNames(view) {
      refetchDayEvents(view.view.type)
    },

    /*
      Handle event drop (Also include dragged event)
      ? Docs: https://fullcalendar.io/docs/eventDrop
      ? We can use `eventDragStop` but it doesn't return updated event so we have to use `eventDrop` which returns updated event
    */
    eventDrop({ event: droppedEvent }) {
      updateEvent(grabEventDataFromEventApi(droppedEvent))
    },

    /*
      Handle event resize
      ? Docs: https://fullcalendar.io/docs/eventResize
    */
    eventResize({ event: resizedEvent }) {
      updateEvent(grabEventDataFromEventApi(resizedEvent))
    },

    // eventContent(eventInfo) {
    //   return { html: eventInfo.event.title }
    // },

    // Get direction from app state (store)
    direction: computed(() => (store.state.appConfig.isRTL ? 'rtl' : 'ltr')),
    rerenderDelay: 350,
  })

  // ------------------------------------------------------------------------

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const isEventHandlerSidebarActive = ref(false)
  const isEventDetailSidebarActive = ref(false)

  const isCalendarOverlaySidebarActive = ref(false)

  return {
    refCalendar,
    isCalendarOverlaySidebarActive,
    calendarOptions,
    eventDetail,
    clearEventData,
    addEvent,
    updateEvent,
    updateEventInCalendar,
    removeEvent,
    refetchEvents,
    fetchEvents,
    customFields,

    // ----- UI ----- //
    isEventHandlerSidebarActive,
    isEventDetailSidebarActive,
    calendarViewName,
  }
}
